import { ParsedUrlQueryInput } from 'node:querystring';
import { UrlObject } from 'url';
import { buildUrlWithQuery } from '.';

export const buildObserveUrl = (fullEntityId: string, query?: ParsedUrlQueryInput): UrlObject =>
  buildUrlWithQuery(
    `/ui/observe/${fullEntityId
      .split(':')
      .map(comp => encodeURIComponent(comp))
      .join('/')}`,
    query,
  );
